<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!--
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
              <img src="static/img/assets/nav_okr_on.png" alt="">
              {{$t('completeOkrType')}}
          </h1>
          <span class="info-right"></span>
        </div>
        <section class="animated fadeInRight flex-option">
          <div v-for="(obj, index) in getCurrentCompletedObjectives" :key="obj.id" v-if="obj.objective.contentText" class="ibox" v-observe-visibility="visibilityChanged" :accessKey="index">
            <div @click="onClickObjective(obj.objective, obj.key)"  class="ibox-title cursor">
              <objective :detailView="false" :content="obj.objective.contentText" :progress="obj.objective.progress ? obj.objective.progress : '0'" :setReadOnly="'false'"  :objective="true" />
              <div class="ibox-tools">
                <span @click.stop="setKeyresultOpen(obj.key)" class="info-menu cursor">
                  <button class="btn btn-secondary">
                    <i :class="{'chevronUp' : !getIsOpen(obj.key)}" class="fa fa-chevron-down"></i>
                    <span v-if="!getIsOpen(obj.key)">{{$t('indicateItemClose')}}</span>
                    <span v-else>{{$t('indicateAllNotice')}}</span>
                  </button>
                </span>
                <span class="info-right">
                  <span class="info-comment-detail">
                    <span class="isExistUnread">
                      <img src="static/img/assets/comment.png">
                      <span v-if="getOKRUnreadCommentKeys('objectives', obj.key, getUserId).length > 0">{{ getOKRUnreadCommentKeys('objectives', obj.key, getUserId).length | lessThanHundred }}</span>
                    </span>
                    <span>{{getCommentsByItemId(obj.key, 'objectives').length}}</span>
                  </span>
                  <div class="info-comment-right">
                  <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                  <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                  </div>
                  <okr-drop-down :tag="tag" :item="obj.objective" :id="obj.key"/>
                </span>
              </div>
            </div>
            <div :class="{'keyResultClose' : getIsOpen(obj.key)}" class="ibox-content key-indent">
                <div @click="onClickObjective(keyresult, key)" v-for="(keyresult, key) in getTargetKeyresults(obj.key)" :key="key" v-if="keyresult.contentText" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult)}">
                  <div class="">
                    <span class="comp"></span>
                    <objective :detailView="false" :content="keyresult.contentText" :progress="keyresult.progress ? keyresult.progress : '0'" :setReadOnly="'false'"  :objective="false" />
                  </div>
                  <div class="info-comment-right">
                    <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                    <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                  </div>
                  <div class="ibox-tools">
                    <span class="info-menu"></span>
                    <span class="info-right">
                      <span class="info-comment-detail">
                        <img src="static/img/assets/comment.png"><span>{{getCommentsByItemId(key,'keyresults').length}}</span>
                      </span>
                      <span class="info-comment-detail due-date-color">{{$t('createDateString')}} : {{keyresult.createdAt|  preparedTime}}</span>
                    </span>
                  </div>
                </div>
          </div>
        </div>
      </section>
    </article>
      -->
      <!-- MainView -->
        <article @click.self="open = false, relationOpen = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
              <img src="static/img/assets/nav_okr_on.png" alt="">
              {{$t('completeOkrType')}}
          </h1>
          <span class="info-right">
              <select-drop-down v-on:set-selected-order="setSelectedOrder" :order="this.orderType"/>
            </span>
        </div>
        <div v-if="isLiteMode">
          <b-alert variant="danger" show>{{$t('liteIsStr')}}</b-alert>
        </div>
        <div v-else>
        <!-- /ViewTitleBox -->
          <section class="animated fadeInRight flex-option">
            <div v-for="(obj, index) in getCurrentCompletedObjectives" :key="obj.id" v-if="obj.key && obj.objective.contentText" class="ibox" v-observe-visibility="visibilityChanged" :accessKey="index">
                <div @click="onClickObjective(obj.objective, obj.key, 'objectives')" class="ibox-title cursor">
                  <objective :detailView="false" :content="obj.objective.contentText" :progress="obj.objective.progress ? '' + obj.objective.progress : '0'" :setReadOnly="'false'" :objective="true" />
                  <div class="ibox-tools">
                    <span @click.stop="setKeyresultOpen(obj.key)" class="info-menu cursor">
                      <button class="btn btn-secondary">
                        <i :class="{'chevronUp' : !getIsOpen(obj.key)}" class="fa fa-chevron-down"></i>
                        <span v-if="!getIsOpen(obj.key)">{{$t('indicateItemClose')}}</span>
                        <span v-else>{{$t('indicateAllNotice')}}</span>
                      </button>
                    </span>
                    <span class="info-right">
                      <span class="info-comment-detail" v-if="obj.objective.hasOwnProperty('sharedOwners') && Object.keys(obj.objective['sharedOwners']).length > 0">
                        <img :src="'static/img/assets/nav_people_on.png'">
                      </span>
                      <span class="info-comment-detail">
                        <span class="isExistUnread">
                          <img v-if="getOKRUnreadCommentKeys('objectives', obj.key, getUserId) > 0" src="static/img/assets/comment_on.png">
                          <img v-else src="static/img/assets/comment.png">
                          <!--
                            <span v-if="getOKRUnreadCommentKeys('objectives', obj.key, getUserId) > 0">{{ getOKRUnreadCommentKeys('objectives', obj.key, getUserId) | lessThanHundred }}</span>
                          -->
                        </span>
                        <span>{{getCommentsByItemId(obj.key, 'objectives').length}}</span>
                      </span>
                      <span class="info-comment-detail">
                        <img src="static/img/assets/relation_object_list.png">
                        <span>{{ obj.objective.relations ? Object.keys(obj.objective.relations).length : 0 }}</span>
                      </span>
                      <div class="info-comment-right">
                      <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                      <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                      </div>
                        <okr-drop-down :tag="tag" :item="obj.objective" :id="obj.key"/>
                    </span>
                  </div>
                </div>
                  <div :class="{'keyResultClose' : getIsOpen(obj.key)}" class="ibox-content key-indent">
                    <!-- ボックス -->
                    <!-- KeyResult1 -->
                    <div @click="onClickObjective(keyresult, key, 'keyresults')" v-for="(keyresult, key) in getTargetKeyresults(obj.objective.keyresults)" :key="key" v-if="keyresult.contentText" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult)}">
                      <div>
                        <span class="comp"></span>
                        <objective :detailView="false" :content="keyresult.contentText" :progress="keyresult.progress ? '' + keyresult.progress : '0'" :setReadOnly="'false'" :objective="false" />
                      </div>
                      <div class="ibox-tools">
                        <span class="info-menu"></span>
                        <span class="info-right">
                          <span class="info-comment-detail">
                            <span class="isExistUnread">
                              <img v-if="getOKRUnreadCommentKeys('keyresults', key, getUserId) > 0" src="static/img/assets/comment_on.png">
                              <img v-else src="static/img/assets/comment.png">
                              <!--
                                <span v-if="getOKRUnreadCommentKeys('keyresults', key, getUserId) > 0">{{ getOKRUnreadCommentKeys('keyresults', key, getUserId) | lessThanHundred }}</span>
                              -->
                            </span>
                            <span>{{getCommentsByItemId(key,'keyresults').length}}</span>
                          </span>
                          <span class="info-comment-detail">
                            <img src="static/img/assets/relation_object_list.png">
                            <span>{{ keyresult.relations ? Object.keys(keyresult.relations).length : 0 }}</span>
                          </span>
                          <div class="info-comment-right">
                            <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                            <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                          </div>
                        </span>
                      </div>
                    </div>
                    <!-- /KeyResult1  -->
                    <div class="ibox-child cursor text-center add-key" style="padding-left:0;">
                        <div id="add-key1" class="panel-footer info-add">
                            <router-link :to="{ name: 'KeyresultRegist', params: { parentObjId: obj.key } }" class="btn btn-success"><i class="fa fa-plus"></i>{{$t('addKeyResultStr')}}</router-link>
                        </div>
                    </div>
                  <!-- /ボックス -->
                </div>
            </div>
        </section>
      </div>
    </article>
    <!-- DetailView -->
      <okr-detail-view :targetItemKey="targetObjectiveKey" :targetType="targetType" :isComplete="true" ref="okrDetailView"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import Objective from '@/components/Okr/Objective'
import OkrDropDown from '@/components/Okr/OkrDropDown'
import CommentItem from '@/components/Comment/CommentItem'
import RelationItem from '@/components/Okr/RelationItem'
import CommentForm from '@/components/Comment/CommentForm'
import CommonJs from '@/js/common'
import OkrDetailView from '@/components/DetailView/OkrDetailView'
import SelectDropDown from '@/components/Okr/SelectDropDown'
import moment from 'moment'
import { liteMode } from '@/main'
export default {
  name: 'OkrComplete',
  mixins: [CommonJs],
  components: {
    Objective,
    OkrDropDown,
    CommentItem,
    RelationItem,
    CommentForm,
    OkrDetailView,
    SelectDropDown
  },
  data: function () {
    return {
      isLiteMode: liteMode,
      tag: 'complete',
      user: [],
      objectiveId: '',
      objectives: [],
      targetType: 'objectives',
      keyresultOpen: {},
      targetObjective: {
        progress: 0,
        contentText: '',
        createdAt: '',
        dueDate: '',
        limitedAccess: {},
        relations: {}
      },
      targetObjectiveKey: '',
      targetComments: {},
      targetKeyresults: {},
      comp: true,
      replyParent: {},
      objectiveCount: 30,
      relationCount: 10
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OkrComplete'
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('keyResults/', [
      'getCurrentKeyresults',
      'getCurrentKeyresultsByIds',
      'getKeyresultsByParentObjId'
    ]),
    ...mapGetters('objectives/', [
      'getCurrentObjectives'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId',
      'getIsReadComment'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByIds'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    getCurrentCompletedObjectives: function () {
      if (this.getCurrentObjectives) {
        let completedObjectives = []
        const currentObjectives = this.getCurrentObjectives
        for (let key in currentObjectives) {
          if (key === '.key') { continue }
          if (currentObjectives[key] && currentObjectives[key].isComplete === 1) {
            completedObjectives.push({key: key, objective: currentObjectives[key]})
          }
        }
        switch ((this.getCurrentUserInfo || {}).okrOrder) {
          case 'updated_desc':
            completedObjectives.sort(function (a, b) {
              return b.objective.modifiedAt - a.objective.modifiedAt
            })
            break
          case 'updated_asc':
            completedObjectives.sort(function (a, b) {
              return a.objective.modifiedAt - b.objective.modifiedAt
            })
            break
          case 'created_asc':
            completedObjectives.sort(function (a, b) {
              return a.objective.createdAt - b.objective.createdAt
            })
            break
          case 'created_desc':
          default:
            completedObjectives.sort(function (a, b) {
              return b.objective.createdAt - a.objective.createdAt
            })
        }
        return completedObjectives.slice(0, this.objectiveCount)
      } else {
        return []
      }
    },
    orderType: function () {
      let ret
      switch ((this.getCurrentUserInfo || {}).okrOrder) {
        case 'updated_desc':
          ret = {
            targetKey: 'modifiedAt',
            isDesc: true
          }
          break
        case 'updated_asc':
          ret = {
            targetKey: 'modifiedAt',
            isDesc: false
          }
          break
        case 'created_asc':
          ret = {
            targetKey: 'createdAt',
            isDesc: false
          }
          break
        case 'created_desc':
        default:
          ret = {
            targetKey: 'createdAt',
            isDesc: true
          }
          break
      }
      return ret
    }
  },
  methods: {
    ...mapActions('users/', {
      setOkrOrderType: 'SET_OKR_ORDER_TYPE'
    }),
    onClickObjective: function (obj, key, type) {
      this.targetObjective = obj
      this.targetObjectiveKey = key
      this.targetType = type
      if (!this.open) {
        this.open = true
      }
      console.log('clicked!', this.open, this.targetObjective)

      if (this.$refs.okrDetailView) {
        this.$refs.okrDetailView.openDetailView()
      }
    },
    getTargetKeyresults (keyresultsObject) {
      // 算出プロパティだと引数がつけられないためmethodに
      return keyresultsObject ? this.getCurrentKeyresultsByIds(Object.keys(keyresultsObject)) : {}
    },
    getIsComp: function (item) {
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete
    },
    getOKRUnreadCommentKeys (itemType, itemId) {
      let items = {}
      if (itemType === 'objectives') {
        items = this.getCurrentObjectives
      } else if (itemType === 'keyresults') {
        items = this.getCurrentKeyresults
      }
      const okrComments = items[itemId].comments
      let unreadCommentKeys = []
      for (const commentKey in okrComments) {
        if (!this.getIsReadComment(commentKey) && !okrComments[commentKey].isDelete) {
          unreadCommentKeys.push(commentKey)
        }
      }
      return unreadCommentKeys
    },
    setKeyresultOpen: function (objectiveId) {
      // console.log(this.keyresultOpen)
      Vue.set(this.keyresultOpen, objectiveId, Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.keyresultOpen[objectiveId])
    },
    getIsOpen: function (objectiveId) {
      // console.log(Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.keyresultOpen[objectiveId])
      return Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.keyresultOpen[objectiveId]
    },
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.objectiveCount - 1) {
        this.objectiveCount += 30
      }
    },
    setSelectedOrder: function (value) {
      if (value.targetKey === 'createdAt') {
        if (value.isDesc) {
          this.setOkrOrderType('created_desc')
        } else {
          this.setOkrOrderType('created_asc')
        }
      } else
      if (value.targetKey === 'modifiedAt') {
        if (value.isDesc) {
          this.setOkrOrderType('updated_desc')
        } else {
          this.setOkrOrderType('updated_asc')
        }
      }
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column;
  }
  /* .key-indent .ibox-child {
    transition: all 0.2s ease-in-out;
    height: 180px;
  } */
  /* .ibox-child.add-key { height: 80px; } */
  .keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  /* .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  } */
</style>



// WEBPACK FOOTER //
// src/views/okr/OkrComplete.vue